import { useState } from 'react';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { solrApis } from '../../../apis/solrApis';
import useToast, { TOAST_TYPE } from '../../../hooks/useToast';
import Text from '../../elements/text/Text';
import Modal from '../../sections/modal/Modal';

const UpconfigButton = ({ selectedCollection }) => {
  const { t } = useTranslation();
  const { showToast } = useToast();
  const { projectId, instanceId } = useParams();

  const [deleteZk, setDeleteZk] = useState(true);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);

  const handleOpenModal = () => {
    setDeleteZk(true);
    setModal(true);
  };
  const handleCloseModal = () => setModal(false);
  const handleCheck = (event) => setDeleteZk(event.target.checked);

  const handleUpconfig = async (clear) => {
    setLoading(true);
    try {
      await solrApis.upconfig(projectId, instanceId, selectedCollection, clear);

      showToast(
        TOAST_TYPE.SUCCESS,
        t('upconfigSuccess', { ns: 'notifications' })
      );
    } catch (error) {
      showToast(TOAST_TYPE.ERROR, t('upconfigError', { ns: 'notifications' }));
    } finally {
      handleCloseModal();
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        disabled={loading}
        startIcon={loading ? <CircularProgress /> : <CloudUploadIcon />}
        onClick={handleOpenModal}
      >
        {t('upconfig', { ns: 'buttons' })}
      </Button>
      <Modal
        openModal={modal}
        title={t('upconfigOptions', { ns: 'instance' })}
        handleClose={handleCloseModal}
        handleConfirm={handleUpconfig}
        showActions
      >
        {deleteZk && (
          <Alert severity="info" style={{ marginBottom: '1em' }}>
            <Text bodyBold style={{ marginBottom: '0.5em' }}>
              {t('upconfigLogInfo', { ns: 'descriptions' })}
            </Text>
            <Text bodyBold>{t('clearSolrErrors', { ns: 'descriptions' })}</Text>
          </Alert>
        )}
        <FormControlLabel
          control={<Checkbox checked={deleteZk} onChange={handleCheck} />}
          label={t('deleteUpconfig', { ns: 'descriptions' })}
        />
      </Modal>
    </>
  );
};

UpconfigButton.propTypes = {
  selectedCollection: PropTypes.string.isRequired,
};

export default UpconfigButton;
